import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _0de79a24 = () => interopDefault(import('../pages/achievement/index.vue' /* webpackChunkName: "pages/achievement/index" */))
const _96b50234 = () => interopDefault(import('../pages/advertise/index.vue' /* webpackChunkName: "pages/advertise/index" */))
const _493e2dee = () => interopDefault(import('../pages/agreement/index.vue' /* webpackChunkName: "pages/agreement/index" */))
const _7475c816 = () => interopDefault(import('../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _35bb4ed6 = () => interopDefault(import('../pages/customer/index.vue' /* webpackChunkName: "pages/customer/index" */))
const _59cd277e = () => interopDefault(import('../pages/details/index.vue' /* webpackChunkName: "pages/details/index" */))
const _b802bd82 = () => interopDefault(import('../pages/goals/index.vue' /* webpackChunkName: "pages/goals/index" */))
const _3dc1734c = () => interopDefault(import('../pages/maisoku/index.vue' /* webpackChunkName: "pages/maisoku/index" */))
const _28d8d063 = () => interopDefault(import('../pages/media/index.vue' /* webpackChunkName: "pages/media/index" */))
const _9fb4aaf8 = () => interopDefault(import('../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _56d63750 = () => interopDefault(import('../pages/project/index.vue' /* webpackChunkName: "pages/project/index" */))
const _7b7fe590 = () => interopDefault(import('../pages/response/index.vue' /* webpackChunkName: "pages/response/index" */))
const _6b805084 = () => interopDefault(import('../pages/sale/index.vue' /* webpackChunkName: "pages/sale/index" */))
const _9ab739d6 = () => interopDefault(import('../pages/achievement/output.vue' /* webpackChunkName: "pages/achievement/output" */))
const _6a5fa9cd = () => interopDefault(import('../pages/achievement/registration.vue' /* webpackChunkName: "pages/achievement/registration" */))
const _e426cd10 = () => interopDefault(import('../pages/advertise/analysis.vue' /* webpackChunkName: "pages/advertise/analysis" */))
const _1c1b625f = () => interopDefault(import('../pages/advertise/management.vue' /* webpackChunkName: "pages/advertise/management" */))
const _8a211256 = () => interopDefault(import('../pages/advertise/registration.vue' /* webpackChunkName: "pages/advertise/registration" */))
const _27a6dae6 = () => interopDefault(import('../pages/calendar/registration.vue' /* webpackChunkName: "pages/calendar/registration" */))
const _28ea2a46 = () => interopDefault(import('../pages/customer/registration.vue' /* webpackChunkName: "pages/customer/registration" */))
const _78dea702 = () => interopDefault(import('../pages/goals/analysis.vue' /* webpackChunkName: "pages/goals/analysis" */))
const _f3199306 = () => interopDefault(import('../pages/goals/setting.vue' /* webpackChunkName: "pages/goals/setting" */))
const _51d7e571 = () => interopDefault(import('../pages/line/tracking/index.vue' /* webpackChunkName: "pages/line/tracking/index" */))
const _2559265c = () => interopDefault(import('../pages/maisoku/export.vue' /* webpackChunkName: "pages/maisoku/export" */))
const _6b86c822 = () => interopDefault(import('../pages/maisoku/template.vue' /* webpackChunkName: "pages/maisoku/template" */))
const _39198843 = () => interopDefault(import('../pages/response/registration.vue' /* webpackChunkName: "pages/response/registration" */))
const _07e55845 = () => interopDefault(import('../pages/sale/output.vue' /* webpackChunkName: "pages/sale/output" */))
const _2539675d = () => interopDefault(import('../pages/setting/announcement/index.vue' /* webpackChunkName: "pages/setting/announcement/index" */))
const _0c29d87b = () => interopDefault(import('../pages/setting/import/index.vue' /* webpackChunkName: "pages/setting/import/index" */))
const _e32fec66 = () => interopDefault(import('../pages/setting/mail-template.vue' /* webpackChunkName: "pages/setting/mail-template" */))
const _27810004 = () => interopDefault(import('../pages/setting/matching-mail.vue' /* webpackChunkName: "pages/setting/matching-mail" */))
const _82c154ee = () => interopDefault(import('../pages/setting/shop.vue' /* webpackChunkName: "pages/setting/shop" */))
const _46e9c2c0 = () => interopDefault(import('../pages/setting/staff/index.vue' /* webpackChunkName: "pages/setting/staff/index" */))
const _0dd5db58 = () => interopDefault(import('../pages/setting/step-mail/index.vue' /* webpackChunkName: "pages/setting/step-mail/index" */))
const _05143fcc = () => interopDefault(import('../pages/setting/tag/index.vue' /* webpackChunkName: "pages/setting/tag/index" */))
const _6d2fd8ec = () => interopDefault(import('../pages/shop/document-template/index.vue' /* webpackChunkName: "pages/shop/document-template/index" */))
const _617d58a5 = () => interopDefault(import('../pages/shop/message/index.vue' /* webpackChunkName: "pages/shop/message/index" */))
const _31f7f28e = () => interopDefault(import('../pages/message/line/edit.vue' /* webpackChunkName: "pages/message/line/edit" */))
const _c6644c36 = () => interopDefault(import('../pages/message/line/log.vue' /* webpackChunkName: "pages/message/line/log" */))
const _138b436b = () => interopDefault(import('../pages/message/line/registration/index.vue' /* webpackChunkName: "pages/message/line/registration/index" */))
const _c27eca2a = () => interopDefault(import('../pages/message/line/select.vue' /* webpackChunkName: "pages/message/line/select" */))
const _5c3d0d92 = () => interopDefault(import('../pages/message/line/send.vue' /* webpackChunkName: "pages/message/line/send" */))
const _45c9bca8 = () => interopDefault(import('../pages/message/mail/log.vue' /* webpackChunkName: "pages/message/mail/log" */))
const _c747d8f6 = () => interopDefault(import('../pages/message/mail/registration.vue' /* webpackChunkName: "pages/message/mail/registration" */))
const _76fa1d48 = () => interopDefault(import('../pages/message/mail/select.vue' /* webpackChunkName: "pages/message/mail/select" */))
const _4861eed4 = () => interopDefault(import('../pages/message/mail/send.vue' /* webpackChunkName: "pages/message/mail/send" */))
const _69526a7e = () => interopDefault(import('../pages/setting/announcement/registration.vue' /* webpackChunkName: "pages/setting/announcement/registration" */))
const _ef93bad0 = () => interopDefault(import('../pages/setting/import/Detail.vue' /* webpackChunkName: "pages/setting/import/Detail" */))
const _65941ba0 = () => interopDefault(import('../pages/setting/import/registration.vue' /* webpackChunkName: "pages/setting/import/registration" */))
const _eaeb1b58 = () => interopDefault(import('../pages/setting/real-estate-agent/property-range.vue' /* webpackChunkName: "pages/setting/real-estate-agent/property-range" */))
const _2be391db = () => interopDefault(import('../pages/setting/staff/registration.vue' /* webpackChunkName: "pages/setting/staff/registration" */))
const _4bb4d3ba = () => interopDefault(import('../pages/setting/step-mail/registration.vue' /* webpackChunkName: "pages/setting/step-mail/registration" */))
const _01101ddc = () => interopDefault(import('../pages/message/line/registration/success.vue' /* webpackChunkName: "pages/message/line/registration/success" */))
const _0f4ac3ce = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _6662af01 = () => interopDefault(import('../pages/message/mail/edit/_id.vue' /* webpackChunkName: "pages/message/mail/edit/_id" */))
const _4624ae66 = () => interopDefault(import('../pages/agreement/log/_id.vue' /* webpackChunkName: "pages/agreement/log/_id" */))
const _4ae643fd = () => interopDefault(import('../pages/agreement/registration/_id.vue' /* webpackChunkName: "pages/agreement/registration/_id" */))
const _f177637c = () => interopDefault(import('../pages/customer/edit/_id.vue' /* webpackChunkName: "pages/customer/edit/_id" */))
const _8487bf3a = () => interopDefault(import('../pages/media/registration/_id.vue' /* webpackChunkName: "pages/media/registration/_id" */))
const _30c9714e = () => interopDefault(import('../pages/project/registration/_id.vue' /* webpackChunkName: "pages/project/registration/_id" */))
const _5002ab32 = () => interopDefault(import('../pages/response/add/_id.vue' /* webpackChunkName: "pages/response/add/_id" */))
const _5078c5f6 = () => interopDefault(import('../pages/setting/announcement/_id.vue' /* webpackChunkName: "pages/setting/announcement/_id" */))
const _4f904908 = () => interopDefault(import('../pages/setting/staff/_id.vue' /* webpackChunkName: "pages/setting/staff/_id" */))
const _6752d3c0 = () => interopDefault(import('../pages/setting/step-mail/_id.vue' /* webpackChunkName: "pages/setting/step-mail/_id" */))
const _05397f66 = () => interopDefault(import('../pages/shop/message/_id.vue' /* webpackChunkName: "pages/shop/message/_id" */))
const _424618d6 = () => interopDefault(import('../pages/achievement/_id.vue' /* webpackChunkName: "pages/achievement/_id" */))
const _ea10cc9e = () => interopDefault(import('../pages/agreement/_id.vue' /* webpackChunkName: "pages/agreement/_id" */))
const _0f6ec3f1 = () => interopDefault(import('../pages/client-history/_id.vue' /* webpackChunkName: "pages/client-history/_id" */))
const _61277c3d = () => interopDefault(import('../pages/customer/_id.vue' /* webpackChunkName: "pages/customer/_id" */))
const _afd4e0ea = () => interopDefault(import('../pages/media/_id.vue' /* webpackChunkName: "pages/media/_id" */))
const _977fc680 = () => interopDefault(import('../pages/project/_id.vue' /* webpackChunkName: "pages/project/_id" */))
const _1928522e = () => interopDefault(import('../pages/property/_property.vue' /* webpackChunkName: "pages/property/_property" */))
const _4abceffc = () => interopDefault(import('../pages/property/_property/contact/index.vue' /* webpackChunkName: "pages/property/_property/contact/index" */))
const _8870ce20 = () => interopDefault(import('../pages/property/_property/contact/confirm.vue' /* webpackChunkName: "pages/property/_property/contact/confirm" */))
const _51f3f4f0 = () => interopDefault(import('../pages/property/_property/contact/send.vue' /* webpackChunkName: "pages/property/_property/contact/send" */))
const _ab4004c0 = () => interopDefault(import('../pages/response/_id.vue' /* webpackChunkName: "pages/response/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/achievement",
    component: _0de79a24,
    name: "achievement"
  }, {
    path: "/advertise",
    component: _96b50234,
    name: "advertise"
  }, {
    path: "/agreement",
    component: _493e2dee,
    name: "agreement"
  }, {
    path: "/calendar",
    component: _7475c816,
    name: "calendar"
  }, {
    path: "/customer",
    component: _35bb4ed6,
    name: "customer"
  }, {
    path: "/details",
    component: _59cd277e,
    name: "details"
  }, {
    path: "/goals",
    component: _b802bd82,
    name: "goals"
  }, {
    path: "/maisoku",
    component: _3dc1734c,
    name: "maisoku"
  }, {
    path: "/media",
    component: _28d8d063,
    name: "media"
  }, {
    path: "/privacy",
    component: _9fb4aaf8,
    name: "privacy"
  }, {
    path: "/project",
    component: _56d63750,
    name: "project"
  }, {
    path: "/response",
    component: _7b7fe590,
    name: "response"
  }, {
    path: "/sale",
    component: _6b805084,
    name: "sale"
  }, {
    path: "/achievement/output",
    component: _9ab739d6,
    name: "achievement-output"
  }, {
    path: "/achievement/registration",
    component: _6a5fa9cd,
    name: "achievement-registration"
  }, {
    path: "/advertise/analysis",
    component: _e426cd10,
    name: "advertise-analysis"
  }, {
    path: "/advertise/management",
    component: _1c1b625f,
    name: "advertise-management"
  }, {
    path: "/advertise/registration",
    component: _8a211256,
    name: "advertise-registration"
  }, {
    path: "/calendar/registration",
    component: _27a6dae6,
    name: "calendar-registration"
  }, {
    path: "/customer/registration",
    component: _28ea2a46,
    name: "customer-registration"
  }, {
    path: "/goals/analysis",
    component: _78dea702,
    name: "goals-analysis"
  }, {
    path: "/goals/setting",
    component: _f3199306,
    name: "goals-setting"
  }, {
    path: "/line/tracking",
    component: _51d7e571,
    name: "line-tracking"
  }, {
    path: "/maisoku/export",
    component: _2559265c,
    name: "maisoku-export"
  }, {
    path: "/maisoku/template",
    component: _6b86c822,
    name: "maisoku-template"
  }, {
    path: "/response/registration",
    component: _39198843,
    name: "response-registration"
  }, {
    path: "/sale/output",
    component: _07e55845,
    name: "sale-output"
  }, {
    path: "/setting/announcement",
    component: _2539675d,
    name: "setting-announcement"
  }, {
    path: "/setting/import",
    component: _0c29d87b,
    name: "setting-import"
  }, {
    path: "/setting/mail-template",
    component: _e32fec66,
    name: "setting-mail-template"
  }, {
    path: "/setting/matching-mail",
    component: _27810004,
    name: "setting-matching-mail"
  }, {
    path: "/setting/shop",
    component: _82c154ee,
    name: "setting-shop"
  }, {
    path: "/setting/staff",
    component: _46e9c2c0,
    name: "setting-staff"
  }, {
    path: "/setting/step-mail",
    component: _0dd5db58,
    name: "setting-step-mail"
  }, {
    path: "/setting/tag",
    component: _05143fcc,
    name: "setting-tag"
  }, {
    path: "/shop/document-template",
    component: _6d2fd8ec,
    name: "shop-document-template"
  }, {
    path: "/shop/message",
    component: _617d58a5,
    name: "shop-message"
  }, {
    path: "/message/line/edit",
    component: _31f7f28e,
    name: "message-line-edit"
  }, {
    path: "/message/line/log",
    component: _c6644c36,
    name: "message-line-log"
  }, {
    path: "/message/line/registration",
    component: _138b436b,
    name: "message-line-registration"
  }, {
    path: "/message/line/select",
    component: _c27eca2a,
    name: "message-line-select"
  }, {
    path: "/message/line/send",
    component: _5c3d0d92,
    name: "message-line-send"
  }, {
    path: "/message/mail/log",
    component: _45c9bca8,
    name: "message-mail-log"
  }, {
    path: "/message/mail/registration",
    component: _c747d8f6,
    name: "message-mail-registration"
  }, {
    path: "/message/mail/select",
    component: _76fa1d48,
    name: "message-mail-select"
  }, {
    path: "/message/mail/send",
    component: _4861eed4,
    name: "message-mail-send"
  }, {
    path: "/setting/announcement/registration",
    component: _69526a7e,
    name: "setting-announcement-registration"
  }, {
    path: "/setting/import/Detail",
    component: _ef93bad0,
    name: "setting-import-Detail"
  }, {
    path: "/setting/import/registration",
    component: _65941ba0,
    name: "setting-import-registration"
  }, {
    path: "/setting/real-estate-agent/property-range",
    component: _eaeb1b58,
    name: "setting-real-estate-agent-property-range"
  }, {
    path: "/setting/staff/registration",
    component: _2be391db,
    name: "setting-staff-registration"
  }, {
    path: "/setting/step-mail/registration",
    component: _4bb4d3ba,
    name: "setting-step-mail-registration"
  }, {
    path: "/message/line/registration/success",
    component: _01101ddc,
    name: "message-line-registration-success"
  }, {
    path: "/",
    component: _0f4ac3ce,
    name: "index"
  }, {
    path: "/message/mail/edit/:id?",
    component: _6662af01,
    name: "message-mail-edit-id"
  }, {
    path: "/agreement/log/:id?",
    component: _4624ae66,
    name: "agreement-log-id"
  }, {
    path: "/agreement/registration/:id?",
    component: _4ae643fd,
    name: "agreement-registration-id"
  }, {
    path: "/customer/edit/:id?",
    component: _f177637c,
    name: "customer-edit-id"
  }, {
    path: "/media/registration/:id?",
    component: _8487bf3a,
    name: "media-registration-id"
  }, {
    path: "/project/registration/:id?",
    component: _30c9714e,
    name: "project-registration-id"
  }, {
    path: "/response/add/:id?",
    component: _5002ab32,
    name: "response-add-id"
  }, {
    path: "/setting/announcement/:id",
    component: _5078c5f6,
    name: "setting-announcement-id"
  }, {
    path: "/setting/staff/:id",
    component: _4f904908,
    name: "setting-staff-id"
  }, {
    path: "/setting/step-mail/:id?",
    component: _6752d3c0,
    name: "setting-step-mail-id"
  }, {
    path: "/shop/message/:id",
    component: _05397f66,
    name: "shop-message-id"
  }, {
    path: "/achievement/:id",
    component: _424618d6,
    name: "achievement-id"
  }, {
    path: "/agreement/:id",
    component: _ea10cc9e,
    name: "agreement-id"
  }, {
    path: "/client-history/:id?",
    component: _0f6ec3f1,
    name: "client-history-id"
  }, {
    path: "/customer/:id",
    component: _61277c3d,
    name: "customer-id"
  }, {
    path: "/media/:id",
    component: _afd4e0ea,
    name: "media-id"
  }, {
    path: "/project/:id",
    component: _977fc680,
    name: "project-id"
  }, {
    path: "/property/:property?",
    component: _1928522e,
    name: "property-property",
    children: [{
      path: "contact",
      component: _4abceffc,
      name: "property-property-contact"
    }, {
      path: "contact/confirm",
      component: _8870ce20,
      name: "property-property-contact-confirm"
    }, {
      path: "contact/send",
      component: _51f3f4f0,
      name: "property-property-contact-send"
    }]
  }, {
    path: "/response/:id",
    component: _ab4004c0,
    name: "response-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
